import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PublicGuard } from './guards/public.guard';
import { AuthGuard } from './guards/auth.guard';
import { ConsentGuard, ConsentPendingGuard } from './guards/consent.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, ConsentGuard],
    loadChildren: () => import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'login',
    canActivate: [PublicGuard],
    loadChildren: () => import('./pages/auth/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'signup',
    canActivate: [PublicGuard],
    loadChildren: () => import('./pages/auth/signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'consent',
    canActivate: [AuthGuard, ConsentPendingGuard],
    loadChildren: () => import('./pages/auth/consent/consent.module').then((m) => m.ConsentPageModule),
  },
  {
    path: 'profile',
    canActivate: [AuthGuard, ConsentGuard],
    loadChildren: () => import('./pages/config/subpages/profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'about-i4life',
    canActivate: [AuthGuard, ConsentGuard],
    loadChildren: () =>
      import('./pages/config/subpages/about-i4life/about-i4life.module').then((m) => m.AboutI4lifePageModule),
  },
  {
    path: 'profile-management',
    canActivate: [AuthGuard, ConsentGuard],
    loadChildren: () =>
      import('./pages/config/subpages/profile-management/profile-management.module').then(
        (m) => m.ProfileManagementPageModule,
      ),
  },
  {
    path: 'role-management',
    canActivate: [AuthGuard, ConsentGuard],
    loadChildren: () =>
      import('./pages/config/subpages/role-management/role-management.module').then((m) => m.RoleManagementPageModule),
  },
  {
    path: 'research-management',
    canActivate: [AuthGuard, ConsentGuard],
    loadChildren: () =>
      import('./pages/config/subpages/research-management/research-management.module').then(
        (m) => m.ResearchManagementPageModule,
      ),
  },
  {
    path: 'group-management',
    canActivate: [AuthGuard, ConsentGuard],
    loadChildren: () =>
      import('./pages/config/subpages/group-management/group-management.module').then(
        (m) => m.GroupManagementPageModule,
      ),
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
